import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"

export const StyledCard = styled(Card)`
  position: relative;
  background-color: ${({theme}) => `${theme.colors.filterChip}`};
  ${css`
    &:hover path {
      fill: white;
    }
  `}
`

export const Image = styled.img`
  margin-right: ${({theme}) => theme.spacing.half};
`

export const Trigger = styled.span`
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
  `}
  position: absolute;
  svg path {
    fill: white;
  }
`
